
import create from './libs/core';
import modules from './modules';

// components
import './components/BrowserDetection';
import './components/CheckDevice';
import './components/LazyLoadImage'
import './components/UserAgent';
import './components/AnimationScrollPage'
import './components/BgVideoOptions'
import './components/header/Header'
import './components/header/Menu'
import './components/Footer'
import './components/ConvertHeight';

// //ADA support ADA
import './components/Popup'
// import './components/SelectC8'
import './components/header/ADAMenu'
import './components/ADA'

import './components/BackgroundVideo';
import './components/CommonSlider';
import './components/CustomScrollBar';
import './components/ModCalculator';
import './components/ModNewCalculator';
import './components/ModSendMail';

document.addEventListener(
  'DOMContentLoaded',
  async () => {
    function loadScript(url, type) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.head.appendChild(script);

      script.addEventListener('load', () => {
        if (type === 'vimeo-api') {
          window.dispatchEvent(new CustomEvent('vimeoPlayerLoaded'));
        }
      });
    }

    window.onYouTubeIframeAPIReady = () => {
      window.dispatchEvent(new CustomEvent('youtubePlayerLoaded'));
    }

    let flagYoutube = false;
    let flagVimeo = false;
    const dataSrc = document.querySelectorAll('[data-src]');
    // Loop through the selected elements
    dataSrc.forEach((element) => {
      const urlString = element.getAttribute('data-src');
      if ((urlString.indexOf('youtube.com') !== -1 || urlString.indexOf('youtu.be') !== -1 || urlString.indexOf('youtube-nocookie.com') !== -1) && !flagYoutube) {
        loadScript('https://www.youtube.com/iframe_api', 'youtube-api');
        flagYoutube = true;
      }

      if (urlString.indexOf('vimeo.com') !== -1 && !flagVimeo) {
        loadScript('https://player.vimeo.com/api/player', 'vimeo-api');
        flagVimeo = true;
      }
    });
    create(modules);
  },
  false,
);

// Hot reload for start dev.
if (import.meta.hot) {
  console.log('Updated vite');
}